import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import checkIcon from '../../../assets/check.svg';

type ICustomCheckbox = {
    children: ReactNode;
    checked: boolean;
    setChecked: (checked: boolean) => void;
};

const CustomCheckbox: FC<ICustomCheckbox> = ({
    checked,
    setChecked,
    children,
}) => {
    return (
        <StyledCustomCheckbox $checked={checked}>
            {children}
            <input
                title="Перезвоните мне"
                type="checkbox"
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
            />
        </StyledCustomCheckbox>
    );
};

const StyledCustomCheckbox = styled.label<{ $checked: boolean }>`
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
    input {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }
    &::before {
        content: '';
        display: block;
        width: 21px;
        height: 21px;
        border: 1px solid #82bf31;
        background: ${({ $checked }) =>
            $checked
                ? `url(${checkIcon}) no-repeat center center / contain;`
                : 'none'};
    }
`;

export default CustomCheckbox;
